import React from "react";

import { ProgressBar }     from 'react-bootstrap';

const QuoteProgress = (props) => {

  const {
    show,
    step,
    total_steps,
  } = props;

  if(!show || total_steps <= 0) return null;

  const now = Math.ceil((step/total_steps)*100);

  return (
    <>
      <ProgressBar now={now} label={`${now}%`} animated/>
      <span>Quoting Parts {step} of {total_steps}</span>
    </>
  )
}

QuoteProgress.defaultProps = {
  show: false,
  step: 0,
  total_steps: 0,
}

export default QuoteProgress;